import Base from '../base.js';

export class Design extends Base {
    constructor(containerId, options){
        options.mode = 1;        
        super(containerId, options);
    }
}